<template>
  <div class="flex flex-col">
    <div>
      <ClientOnly>
        <Swiper
          class="swiper"
          @swiper="emit('on-swiper', $event)"
          @slide-change="emit('on-slide-change', $event.activeIndex)"
        >
          <SwiperSlide
            v-for="(slide, index) in slides"
            :key="`documents-slider-${index}`"
          >
            <div
              class="swiper-slide cursor-pointer"
              @click="showLightbox(index)"
            >
              <img
                v-lazy-load
                :src="slide.preview"
                alt=""
                class="size-full object-cover"
              />
            </div>
          </SwiperSlide>
        </Swiper>
      </ClientOnly>
    </div>
  </div>
</template>

<script setup>
import 'swiper/css';

import { Fancybox } from 'fancyapps-ui';
import { Swiper, SwiperSlide } from 'swiper/vue';

const props = defineProps({
  slides: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['on-swiper', 'on-slide-change']);

const showLightbox = (index) => {
  const images = props.slides.map((el) => {
    const image = el.src ? el.src : el.preview;
    return {
      src: image,
    };
  });
  Fancybox.show(images, {
    startIndex: index,
    compact: false,
    contentClick: 'iterateZoom',
    Images: {
      Panzoom: {
        maxScale: 2,
      },
    },
    Thumbs: {
      type: 'classic',
      showOnStart: false,
      thumbTpl:
        '<button type="button" aria-label="{{GOTO}}"><img class="f-thumb" data-not-lazy data-lazy-src="{{%s}}" alt="" /></button>',
    },
  });
};
</script>
